"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REQUIRES_4_STARS = exports.REQUIRES_3_STARS = exports.REQUIRES_2_STARS = exports.REQUIRES_30_COMPLETED_OPERATIONS = exports.REQUIRES_20_COMPLETED_OPERATIONS = exports.REQUIRES_10_COMPLETED_OPERATIONS = exports.REQUIRES_TIER_ENHANCED_VERIFIED = exports.REQUIRES_TIER_VERIFIED_SELL = exports.REQUIRES_TIER_VERIFIED_BUY = exports.SELL_ONLY = exports.BUY_ONLY = void 0;
exports.BUY_ONLY = 'BUY_ONLY';
exports.SELL_ONLY = 'SELL_ONLY';
exports.REQUIRES_TIER_VERIFIED_BUY = 'TIER_VERIFIED_BUY';
exports.REQUIRES_TIER_VERIFIED_SELL = 'TIER_VERIFIED_SELL';
exports.REQUIRES_TIER_ENHANCED_VERIFIED = 'REQUIRES_TIER_ENHANCED_VERIFIED';
exports.REQUIRES_10_COMPLETED_OPERATIONS = 'REQUIRES_10_COMPLETED_OPERATIONS';
exports.REQUIRES_20_COMPLETED_OPERATIONS = 'REQUIRES_20_COMPLETED_OPERATIONS';
exports.REQUIRES_30_COMPLETED_OPERATIONS = 'REQUIRES_30_COMPLETED_OPERATIONS';
exports.REQUIRES_2_STARS = 'REQUIRES_2_STARS';
exports.REQUIRES_3_STARS = 'REQUIRES_3_STARS';
exports.REQUIRES_4_STARS = 'REQUIRES_4_STARS';
